// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-box[data-v-42a1d31c]{align-items:center;background-color:#fff;border:1px solid #ced4da;border-radius:4px;display:flex;flex:1 0 0;height:42px;margin:8px 0}.button-box .gi[data-v-42a1d31c]{color:#868e96;font-size:20px;margin-right:8px}.button-box .truncate[data-v-42a1d31c]{overflow:hidden;text-align:left;text-overflow:ellipsis;white-space:nowrap;width:80%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
